module.exports = __webpack_public_path__ + "40577bb1d90b0b3b1683d1a5b54e5aad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/marker.svg
// module id = 764
// module chunks = 0